import { useState, useContext } from 'react';
import clienteAxios from '../config/axios';
import AuthContext from '../context/autenticacion/authContext';

function useUsuarioAutenticado() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const authContext = useContext(AuthContext);
    const { usuarioAutenticadoData, usuarioAutenticadoError } = authContext;

    function init() {
        setData(null);
        setLoading(true);
        setLoading(false)
    }

    async function load() {
        init();
        setLoading(true);

        //if (localStorage.getItem('token')) {
            try {
                if(!data){
                    const result = await clienteAxios.get('/auth', ''); 
                    setData(result.data.usuario);
                    usuarioAutenticadoData(result.data.usuario) 
                }
            } catch (e) {
                setError(true);
                usuarioAutenticadoError(e);
            }
        //}
        setLoading(false);
    }

    return [data, loading, error, load];
}

export default useUsuarioAutenticado;